import { styled } from '@mui/material';
import { IconButton } from 'core/common/ui/ui-kit';
import Icon from 'core/svg-sprites/ui/Icon';

export const PlaceholderStyled = styled('div')`
  width: 24px;
  min-width: 24px;
  height: 24px;
  margin-right: 32px;
`;

export const ButtonBackStyled = styled(IconButton)`
  width: 24px;
  min-width: 24px;
  height: 24px;
  margin-right: 32px;
  color: ${({ theme }) => theme.palette.header.backButton.color};
`;

export const IconStyled = styled(Icon)`
  width: 24px;
  height: 24px;
  transform: rotate(90deg);
  fill: currentColor;
`;
